"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4656],{

/***/ 13311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var QuadrilateroVerde = function QuadrilateroVerde(_ref) {
  var color = _ref.color,
      flip = _ref.flip,
      w = _ref.w,
      h = _ref.h;
  var width = w || 372;
  var height = h || 346;
  var directionStyle = flip ? "scale(-1, 1) translate(-".concat(width, ", 0)") : '';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: "Quadrilatero verde"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("g", {
      id: "greenBackground",
      transform: directionStyle,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        fill: color || '#1f855f',
        id: "svg_1",
        d: "\n        m 0,10\n        c 0,-5 5,-10 11,-10\n        l ".concat(width - 22, ",0\n        c 6,0 11,4 11,10\n        l -45,").concat(height - 20, "\n        c 0,5 -5,10 -11,10\n        l -").concat(width - 68, ",0\n        c -6,0 -11,-4 -11,-10\n        "),
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (QuadrilateroVerde);

/***/ }),

/***/ 4656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48641);
/* harmony import */ var src_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75713);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58598);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3382);
/* harmony import */ var public_images_quadrilatero_verde__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13311);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);










var BeforeNltSection = function BeforeNltSection(_ref) {
  var image = _ref.image,
      title = _ref.title,
      items = _ref.items,
      href = _ref.href,
      action = _ref.action,
      actionTitle = _ref.actionTitle,
      footer = _ref.footer;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
    bg: "baseWhite",
    pb: "xxl4",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(src_components__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Grid */ .rj, {
        templateColumns: "repeat(3, 1fr)",
        gap: 4,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .GridItem */ .P4, {
          colSpan: 2,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .xv, {
            color: "baseDark",
            fontFamily: "Montserrat-SemiBold",
            fontSize: "1.5rem",
            lineHeight: "31.2px",
            letterSpacing: "0.68px",
            textAlign: "left",
            marginBottom: "l",
            children: title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_3__/* .ListWithDescription */ .pN, {
            items: items
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .GridItem */ .P4, {
          position: "relative",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
            position: "absolute",
            h: "17.25rem",
            right: "0",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(public_images_quadrilatero_verde__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              flip: true,
              color: "#2ec58d",
              h: 278,
              w: 267
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
            position: "absolute",
            top: "calc(50% - 60px)",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
              src: image,
              alt: title,
              width: "393",
              height: "156",
              objectFit: "contain",
              loading: "lazy",
              decoding: "async"
            }), href && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(src_uikit__WEBPACK_IMPORTED_MODULE_3__/* .TextLink */ .hh, {
              fontFamily: "Montserrat-Medium",
              fontSize: "1rem",
              color: "baseDark",
              href: href,
              title: actionTitle,
              children: [action, " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_7__/* .ArrowForwardIcon */ .mr, {})]
            })]
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .xv, {
        color: "baseDark",
        fontFamily: "Montserrat-Medium",
        fontSize: ".75rem",
        lineHeight: "15.6px",
        letterSpacing: "0.4px",
        textAlign: "left",
        paddingTop: "xxl",
        children: footer
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (BeforeNltSection);

/***/ })

}]);